import { SupportedDateParts } from '../../utils/date-format-parts';

import type { DateFieldValue } from './types';

export const deserializeDate = (value?: string): DateFieldValue => {
  if (!value) {
    return {
      [SupportedDateParts.YEAR]: '',
      [SupportedDateParts.MONTH]: '',
      [SupportedDateParts.DAY]: '',
    };
  }

  const [year, month, day] = value.split('-');

  return {
    [SupportedDateParts.YEAR]: year,
    [SupportedDateParts.MONTH]: month ? String(parseInt(month, 10)) : '',
    [SupportedDateParts.DAY]: day ? String(parseInt(day, 10)) : '',
  };
};

export function serializeDate(
  value: string,
  datePart: SupportedDateParts | 'time',
  currentDate: DateFieldValue,
): string {
  const newYear =
    datePart === SupportedDateParts.YEAR
      ? value
      : currentDate[SupportedDateParts.YEAR];
  const newMonth =
    datePart === SupportedDateParts.MONTH
      ? value
      : currentDate[SupportedDateParts.MONTH];
  const newDay =
    datePart === SupportedDateParts.DAY
      ? value
      : currentDate[SupportedDateParts.DAY];

  const yearFormatted = newYear || '';
  const monthFormatted = newMonth ? newMonth.padStart(2, '0') : '';
  const dayFormatted = newDay ? newDay.padStart(2, '0') : '';

  return [yearFormatted, monthFormatted, dayFormatted].join('-');
}

export function getFocusFieldId(
  id: string,
  datePart: SupportedDateParts,
): string {
  return `${id}/${datePart}`;
}
